import { FieldAttributes } from '~/legacy-components/CustomDataFields';
import { fetchFromOldApi } from '~/services/Http';

import { EmpPositionProposalPostData } from './postData';

export {
  getCustomDataUnitPosition,
  customDataAttributes,
} from './customDataUnitPosition';
export { getManagerIds } from './managerIds';
export * from './postData';

export const submitEmpPositionWorkflow = async (
  empId: number,
  data: EmpPositionProposalPostData,
  proposalId?: string,
) => {
  const api = proposalId
    ? `/json/employee/${empId}/dev/posproposal/internal/${proposalId}`
    : `/json/employee/${empId}/dev/posproposal/internal`;
  return await fetchFromOldApi(api, {
    method: proposalId ? 'PUT' : 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  })
    .then((r) => r.text())
    .catch((e) => {
      const errorResult = e.text();
      return errorResult.then((r: string) => {
        try {
          const rObject = JSON.parse(r);
          if (rObject?.error?.detail?.includes('taxNumber')) {
            return { error: 'laDupTaxNum' };
          }
          return { error: 'laGeneralError' };
        } catch (e) {
          return { error: 'laGeneralError' };
        }
      });
    });
};

export const getCustomCostCenterFieldAttributes = async (): Promise<
  FieldAttributes[]
> =>
  await fetchFromOldApi(
    '/json/customdata/entity/COST_CENTER/attribute?includeInactive=false',
  ).then((r) => r.json());
